import type { HiredEquipmentRowAttachment } from '../types';

/** V3-014 (WRAP-2073): HE line attachments are PDF only – the picker offers PDF alone. */
export const HE_ATTACHMENT_ACCEPT = 'application/pdf,.pdf';

export const HE_ATTACHMENT_PDF_ONLY_MESSAGE = 'Upload a PDF.';

export function isAllowedHiredEquipmentAttachment(file: File): boolean {
  const type = (file.type || '').toLowerCase();
  if (type === 'application/pdf') return true;
  return (type === '' || type === 'application/octet-stream') && /\.pdf$/i.test(file.name);
}

export function attachmentFromDto(dto: HiredEquipmentRowAttachment): HiredEquipmentRowAttachment {
  return {
    filename: dto.filename,
    contentType: dto.contentType,
    size: dto.size,
    url: dto.url,
    key: dto.key,
  };
}
